import React, { useEffect, useState } from "react";
import { Users, Phone, Flame } from "lucide-react";
import AppLayout from "@/components/AppLayout";
import api from "@/lib/api";

const rm = (n) => "RM " + (n || 0).toLocaleString("en-MY");
const STATUS = { new: "bg-blue-500/15 text-blue-400", contacted: "bg-amber-500/15 text-amber-400", won: "bg-emerald-500/15 text-emerald-400" };

export default function Leads() {
  const [leads, setLeads] = useState([]);
  useEffect(() => { api.get("/leads").then((r) => setLeads(r.data)); }, []);

  return (
    <AppLayout active="leads">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight flex items-center gap-2"><Users className="h-6 w-6 text-[#E5253A]" /> Leads / CRM</h1>
        <span className="text-sm font-mono text-muted-foreground">{leads.length} leads</span>
      </div>

      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <div className="hidden md:grid grid-cols-[1.2fr_1fr_1.5fr_1fr_0.8fr_0.8fr] gap-3 px-5 py-3 border-b border-border text-[11px] font-mono text-muted-foreground uppercase">
          <span>Lead</span><span>Phone</span><span>Session · Host</span><span>Product</span><span>Intent</span><span>Value</span>
        </div>
        {leads.map((l) => (
          <div key={l.id} data-testid={`lead-row-${l.id}`} className="grid md:grid-cols-[1.2fr_1fr_1.5fr_1fr_0.8fr_0.8fr] gap-2 md:gap-3 px-5 py-3 border-b border-border last:border-0 items-center text-sm">
            <div className="flex items-center gap-2">
              <span className="font-medium">{l.name}</span>
              <span className={`text-[9px] font-mono px-1.5 py-0.5 rounded-full ${STATUS[l.status] || "bg-accent"}`}>{l.status}</span>
            </div>
            <div className="text-xs font-mono text-muted-foreground flex items-center gap-1"><Phone className="h-3 w-3" /> {l.phone || "—"}</div>
            <div className="text-xs"><div className="truncate">{l.session_title || l.source}</div><div className="text-[10px] text-muted-foreground">{l.host}</div></div>
            <div className="text-xs text-muted-foreground truncate">{l.product || "—"}</div>
            <div className="flex items-center gap-1 text-xs font-mono"><Flame className={`h-3 w-3 ${l.intent > 85 ? "text-amber-400" : "text-muted-foreground"}`} /> {l.intent}%</div>
            <div className="text-xs font-mono font-bold text-emerald-400">{l.value ? rm(l.value) : "—"}</div>
          </div>
        ))}
        {leads.length === 0 && <div className="p-12 text-center text-muted-foreground text-sm">No leads yet.</div>}
      </div>
    </AppLayout>
  );
}
